import { Popover as PopoverComponent } from '@mantine/core'

export const Popover = PopoverComponent.extend({
  defaultProps: { shadow: 'md' },
})
